/*************************************************************************
 *
 * KLEARNOW CONFIDENTIAL
 * __________________
 *
 *  Copyright (c) 2018 - 2020 KLEARNOW Corporation.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of KLEARNOW Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KLEARNOW Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KLEARNOW Corporation.
 */
import { saveHeaderReason, saveLineReason, savePscData } from '../api/setFormData'
const initialState = {
  // initialValues
}

export default function PSCReducer(state = initialState, action) {
  switch (action.type) {
    case 'TRIGGER_PSC': {
      return Object.assign({}, state, { trigger_PSC: true })
    }
    case 'UN_TRIGGER_PSC': {
      return Object.assign({}, state, { trigger_PSC: false })
    }

    case 'INITIALIZE_VALUES_PSC': {
      console.log("REDUCER ===== INITIALIZE_VALUES_PSC");
        window.pscShipmentId = action.pscShipmentId;
        let psc = { ...action.payload,  pscShipmentId: action.pscShipmentId }
        return Object.assign({}, psc)
    }
    case 'SAVE_HEADER_REASON': {
        let psc = {...state}
        let headerReason = psc.headerCodes || [];
        let newHrdReason = headerReason.filter((item)=>{
          return item && item.key && (item.key !== action.tabName)
        })
       newHrdReason.push({
          key: action.tabName,
          reasonCodes: action.headerReason
        })
        saveHeaderReason(action);
        psc.headerCodes = newHrdReason;
        return Object.assign({}, state, psc)
      }
  
      case 'SAVE_LINE_REASON': {
        let psc = {...state}
        let lineReason = psc.lineCodes || [];
        let newLineReason = lineReason.filter((item)=>{
          return item && item.key && (item.key !== action.merchandiseId)
        })
        newLineReason.push({
          lineItemIndex: action.lineItemIndex+1,
          key: action.merchandiseId,
          reasonCodes: action.lineReason
        })
        saveLineReason(action);
        psc.lineCodes = newLineReason;
        return Object.assign({}, state, psc)
      }
      
      case 'SAVE_PSC_DATA': {
        savePscData(action.payload);
        return state;
      }
      case 'UPDATE_PSC_DATA':{
        let psc = {...state, ...action.payload}
        return Object.assign({}, state, psc)
      }
    default:
      return state
  }
}
